import Molde from "./MoldeTrek";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import React from 'react';


export default function Choquequirao4D() {

  const tourItemsIncluye = [
  "Información previa al tour: Te reunirás con tu guía de Salkantay en nuestras oficinas (u otro lugar acordado) alrededor de las 18:00 horas para una sesión informativa sobre su tour.",
"Transporte",
"Recojo de su hotel en Cusco.",
"Transporte turístico de Cusco a Challacancha (Soraypampa).",
"Transporte turístico desde Lucmabamba hasta la Hidroeléctrica.",
"Bus Consettur a la ciudadela de Machu Picchu.",
"Bus Consettur de retorno desde la ciudadela de Machu Picchu.",
"Tren turístico Expeditions de Machu Picchu pueblo a Ollantaytambo / Poroy.",
"Transporte turístico de Ollantaytambo / Poroy a Cusco.",
"Personal",
"Guía profesional altamente calificado de habla inglesa y española para el CHOQUEQUIRAO.",
"Guía profesional altamente calificado de habla inglesa y española para Machu Picchu.",
"Chef y asistente especializado en cocina de montaña, que preparará las comidas durante nuestra caminata.",
"Tickets de ingreso",
"Tickets de ingreso a Salkantay / Lago Humantay.",
"Tickets de ingreso al Sitio Arqueológico de Machu Picchu.",
"Alojamiento y comidas",
"1ra noche: Soraypampa Sky Lodge, acamparemos bajo la atenta mirada de los Apus, montañas Sagradas Humantay y Salkantay. Tendremos suficiente tiempo contemplando las estrellas a través de tu elegante techo de cristal.",
"2da noche: Cabañas en Chaullay, con cómodas camas y colchones, hoy acamparemos rodeados de las Montañas y con menos frío.",
"3ra noche: Lucmabamba Sky Lodge, en nuestros domos encontrarás una cómoda cama, twin o matrimonial (dependiendo de sus preferencas indicadas). Este día el paisaje es más cálido, rodeado de un bosque nuboso y cerca de familias locales.",
"4ta noche: Hotel en Machupicchu pueblo, Aguas Calientes. Está incluido el Hotel Casa de la Luz de 2 estrellas o similar, conocido por sus habitaciones dobles o triples con baño privado, ducha de agua caliente, WiFi, desayuno y resguardo de equipaje durante su visita a Machu Picchu. Alternativamente, puede actualizar a un hotel de 3 o 4 estrellas si lo solicita.",
"3 desayunos, 3 almuerzos, 3 cenas (vegetariana, vegana, sin gluten, sin coste adicional).",
"Suministro de agua hervida, filtrada y refrigerada desde el primer almuerzo hasta el penúltimo desayuno. Recomendamos traer sus propias botellas de agua (3 litros aproximadamente).",
"Mate de coca todas las mañanas en el camping.",
"Hora del té diaria después de la caminata (3 días).",
"Otros",
"Podemos proporcionarles una bolsa de lona para su equipaje personal, de hasta 5 kg (11,02 lbs), incluido su saco de dormir. Esta bolsa será llevada por nuestros caballos y debe ser devuelta al final del recorrido.",
"Botiquín de primeros auxilios, incluida una botella de oxígeno de emergencia.",
"Servicio de Atención al Cliente las 24 horas: Ofrecemos un servicio telefónico disponible las 24 horas del día."
];
const tourItemsNoIncluye = [
"Los bastones de trekking no están incluidos, pero son muy recomendables para la caminata. Puedes traer el suyo o alquilarlo con nosotros.",
"Bolsa de dormir.",
"Entradas adicionales (Montaña Huayna Picchu, Montaña Machu Picchu o Huchuy Picchu).",
"El primer desayuno y el último almuerzo no están incluidos.",
"Tren de Hidroelectrica a Aguas Calientes.",
"Tickets de ingreso para las aguas termales de Santa Teresa y las aguas termales de Aguas Calientes.",
"Costos adicionales o retrasos fuera de nuestro control, como desastres naturales, condiciones climáticas adversas, modificaciones de itinerario por problemas de salud de los pasajeros (que padecen una enfermedad o problemas de salud), pandemia, cambios en las políticas gubernamentales, inestabilidad política, huelgas, etc."
];
const extras =[
  "Bastones de trekking. ($15.00 USD)",
"Bolsas de dormir 3kg. ($25.00 USD)",
"Desayuno económico en Mollepata. ($10.00 USD)",
"Almuerzo Económico en Machupicchu pueblo. ($15.00 USD)",
"Almuerzo en Sanctuary Lodge (Machupicchu pueblo). ($45.00 USD)",
"Cama simple (personal) en los campamentos. ($50.00 USD)",
"Caballo de carga, límite de peso 20 kg. ($90.00 USD)",
"Caballo de silla, para una persona. ($150.00 USD)",
"Tren de Hidroeléctrica a Agua Calientes. ($36.00 USD)",
"Ingreso a la montaña de Huayna Picchu, sujeto a disponibilidad y horarios: 7:00 am / 8:00 am / 9:00 am / 10:00 am ($60.00 USD)",
"Ingreso a la montaña Machupicchu*, sujeto a disponibilidad y horarios: 7:00 am / 9:00 am ($60.00 USD)",
"Ingreso a la montaña Huchuy Picchu, sujeto a disponibilidad y 5 horarios: 7:00, 8:00, 9:00, 10:00, 11:00 y 12:00 am ($60.00 USD)",
"Tour guiado por la montaña Huayna Picchu o montaña Machupicchu*. ($75.00 USD por grupo)",
"Actualice su servicio de tren Vistadome en el regreso. ($50.00 USD)",
"Actualice su servicio de tren Vistadome Observatory en el regreso. ($75.00 USD)",
"Podemos ayudarle en la reserva de hoteles (estándar y de lujo) en todo el Perú.",
];
const llevar =[
  "Pasaporte original (y carné de estudiante válido si corresponde).",
"Artículos de higiene personal o day Pack.",
"Medicación personal.",
"Chaqueta impermeable/poncho de lluvia.",
"Ropa abrigada, gorro para el sol, gafas de sol y guantes.",
"Botas/zapatos de montaña.",
"Calcetines de senderismo.",
"Ropa casual de montaña para las noches.",
"Camisetas de manga corta o larga.",
"Pantalones cómodos, pantalones de trekking.",
"Chaqueta para el clima frío.",
"Protector solar (recomendado SPF 35).",
"Botellas reutilizables de plástico o metal, o camelbak.",
"Repelente de insectos.",
"Sombrero para el sol.",
"Cámara, videocámara y cargadores.",
"Linterna con batería extra.",
];
const arti_adi=[
  "Bermudas.",
"Bastones de trekking (con punta de goma).",
"Vendas y vendajes.",
"Zapatos/chanclas cómodas.",
"Ropa superior transpirable y de ajuste seco.",
"Sandalias.",
"Traje de baño para las aguas termales.",
"Prismáticos.",
"Dinero extra para gastos personales, propinas (se recomiendan 200 nuevos soles peruanos para el dinero extra).",
];
const importante=[
  "El itinerario puede cambiar según el gobierno peruano, las condiciones climáticas y el estado de salud de los excursionistas.",
"El horario de los trenes puede variar dependiendo de la disponibilidad de la compañía de trenes.",
"Proporcionamos el tren Expedition a Ollantaytambo: si alguien reserva un billete de tren en el último momento, no se garantiza que pueda estar en el mismo tren que el resto del grupo.",
"Si desea cambiar el horario o los boletos de su tren, deberá pagar una tarifa adicional por el transporte de Ollantaytambo a Cusco y por la diferencia de precio del tren.",

];
  return (
    <>
      <Molde
        image={"/images/choquequirao-portada.png"}
        title={"CHOQUEQUIRAO"}
        subtitle={"4 DÍAS"}
        description={
          "La caminata compleja de Choquequirao es muy fascinante y uno de los viajes más populares en la zona de Cusco. Y no es una sorpresa, ya que está rodeado de fantásticos paisajes naturales con valles, montañas cubiertas de nieve y una increíble variedad de plantas, pájaros y animales. Está situado en el espolón de la cordillera del Salkantay, a más de 3030 metros sobre el nivel del mar, rodeado por los Apus (dioses de la montaña) de Yamana, Ampay, Chokecarpu, Pumasiyo y Panta, en la margen izquierda del río Apurimac. Durante el tiempo de los Incas, todo estaba conectado y en comunicación con Machu Picchu a través de una compleja red de senderos. Choquequirao es considerado El último refugio del Imperio Inca. Los visitantes tendrán la oportunidad de descubrir un sistema hidráulico complejo, muy probablemente para uso doméstico, ceremonial y agrícola. La ubicación geográfica de Choquequirao en referencia a otros centros religiosos de la misma época tiende a indicar que su función era ese enclave incaico hacia los valles del río Apurímac. Hay muchas similitudes entre Choquequirao y Machu Picchu."
        }
        linkForm={"/reservar/citytour-dia"}
        /*tipoprecio={"Precio por persona"}
        monto={"US$ 1000.00"}
        moneda={"DOLARES"}*/
        mapa={
          <>
            <img className="rounded-lg border-primary-800 border-2" src={`${process.env.PUBLIC_URL}/images/mapa_salkantay_trek.png`} alt="" />
          </>
        }
        itinerario={<>
            <div className="mb-4">
                <h1 className="font-bold text-primary-800 pb-4">ITINERARIO</h1>
                <div className="bg-primary-800 p-2 rounded-lg w-full">
                    <h2 className="text-primary-50 font-bold">Día 1 | CHOQUEQUIRAO</h2>
                </div>
                <h4 className="text-primary-800 py-4 font-semibold">Cusco – Lima Tambo Ruins – Cachora – Chiquisca</h4>                            
                <div className="mt-2 text-primary-800">
                    <p className="mb-2">A las 5:00 am los recogeremos de su hotel y nos iremos de Cusco en nuestra camioneta privada que nos lleva al pueblo de San Pedro de Cachora (2800m). Allí tienes mucho tiempo para probar un desayuno local (no incluido en el paquete, aunque el precio es bastante razonable). Nos reuniremos con el resto de nuestro equipo (cocineros y arrieros) y comenzaremos nuestra larga caminata del día, nos llevará entre 7 y 8 horas en esta región montañosa. En el camino observaremos diversos paisajes típicos de los diferentes climas de la zona con vistas como la montaña nevada de Pedroyoc o incluso la diversidad de flora y fauna que realzan nuestra experiencia.</p>
                    <p className="mb-2">Finalmente llegaremos al mirador de Capulichayoc desde donde podremos observar el cañón más profundo del mundo, el Apurímac, con el río Apurímac en la parte inferior. Aquí tenemos nuestro primer almuerzo y nuestras primeras vistas de Choquequirao. Una vez que descansamos, continuamos descendiendo hasta Chiquisca (1800m) donde instalamos las carpas y pasamos la noche rodeados de maravillosos paisajes.</p>
                </div>
            </div>
            <div>
                <div className="bg-primary-800 p-2 rounded-lg w-full">
                    <h2 className="text-primary-50 font-bold">Día 2 | CHOQUEQUIRAO</h2>
                </div>
                    <h4 className="text-primary-800 py-4 font-semibold">Chiquisca – Maranpata – Choquequirao Ruins</h4>
                <div className="mt-2 text-primary-800">
                    <p className="mb-2">Después de un buen desayuno, comenzamos una extenuante caminata de 5 horas hasta nuestro almuerzo en Marcapata. Aquí tendremos una visita guiada a Choquequirao (la "Cuna Dorada"), considerada la Ciudad Hermana de Machu Picchu por las muchas similitudes que comparten. Choquequirao está a 1500 metros sobre el cañón del Apurímac, mientras que Machu Picchu está hacia el cañón del Urubamba, tienen la misma latitud, y ambas son grandes ciudadelas de más de 8 hectáreas, y hasta ahora solo se ha descubierto un tercio.</p>
                    <p className="mb-2">Los arqueólogos hacen nuevos descubrimientos todos los días. Exploraremos los tres niveles de las ruinas excavadas, apreciando las diversas casas, terrazas y otros elementos de este pueblo inca tardío. Acamparemos al lado de Marcapata.</p>
                </div>
            </div>
            <div>
                <div className="bg-primary-800 p-2 rounded-lg w-full">
                    <h2 className="text-primary-50 font-bold">Día 3 | CHOQUEQUIRAO</h2>
                </div>
                <h4 className="text-primary-800 py-4 font-semibold">Choquequirao Ruins – Chiquisca</h4>                
                <div className="mt-2 text-primary-800">
                    <p className="mb-2">Después de tomar un delicioso desayuno orgánico, comienza el misterioso recorrido en Choquequirao, comenzaremos con nuestra experiencia de caminata guiada al Complejo Arqueológico de Choquequirao que tomará aproximadamente 2 horas, y más tarde algo de tiempo libre en la ciudad inca perdida, Choquequirao (Cuna de oro), sector Llamas, Ushnu Ceremonial y Zona Religiosa.</p>
                    <p className="mb-2">Considerada como la hermana de Machu Picchu, ya que existen varias similitudes, también se encuentra a 1500 metros sobre el Canon Apurímac, solo se ha descubierto una tercera parte de este Complejo Arqueológico y aún muchos arqueólogos encuentran algo interesante cada vez. </p>
                </div>
            </div>
            <div>
                <div className="bg-primary-800 p-2 rounded-lg w-full">
                    <h2 className="text-primary-50 font-bold">Día 4 | CHOQUEQUIRAO</h2>
                </div>
                <h4 className="text-primary-800 py-4 font-semibold">Chiquisca – Cachora – Cusco</h4>
                <div className="mt-2 text-primary-800">
                    <p className="mb-2">Un comienzo temprano hoy nos ayudará a evitar lo peor del calor en el cañón y nos garantizará unas magníficas vistas del Apurímac y los picos circundantes. En nuestro viaje, llegamos al mirador de Capuliyoc por última vez, donde nos despedimos de las fabulosas vistas de las ruinas de Choquequirao. También veremos el majestuoso pico cubierto de nieve de Padreyoc con vistas al Cañón de Apurimac mientras estamos rodeados por la flora y forna especiales de esta área. Luego ascenderemos a nuestro destino final de San Pedro de Cachora para regresar a Cusco en autobús.</p>
                </div>
            </div>
                            </>
        }
        galeria={
            <>
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_3.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_4.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_5.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_6.png`} alt="" />
            </>
          }
        incluye={
            <ul className="space-y-3">
                {tourItemsIncluye.map((item, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                    <span className="text-green-600 font-bold mt-1">✔</span>
                    <span className="text-primary-800">{item}</span>
                </li>
                ))}
            </ul>
        }
        
        noIncluye={
            <ul className="space-y-3">
                {tourItemsNoIncluye.map((item, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                    <span className="text-red-600 font-bold mt-1">✖</span>
                    <span className="text-primary-800">{item}</span>
                </li>
                ))}
            </ul>
        }
        extras={
            <ul className="space-y-3">
                {extras.map((item, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                    <span className="text-blue-600 font-bold mt-1">➕</span>
                    <span className="text-primary-800">{item}</span>
                </li>
                ))}
            </ul>
        }
        llevarTrek={
          <ul className="space-y-3">
            {llevar.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        articulo_add={
          <ul className="space-y-3">
            {arti_adi.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        importante={
          <ul className="space-y-3">
          {importante.map((item, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
              <span className="text-yellow-600 font-bold mt-1">❗</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
        }

        caracteristica={
          <>
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
              title={"Dificultad"}
              desc={"Dificil"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
              title={"Tipo Servicio"}
              desc={"4/10 personas"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
              title={"Duración"}
              desc={"4 Días/3 Noche"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
              title={"Tipo de Tour"}
              desc={"Trekking"}
            />
          </>
        }
        
        TourRecomienda={
                  <>
                    <CardRecomienda
                      img={"/images/montania_colores.png"}
                      title={"MONTAÑA 7 COLORES"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/montania-colores'}
                    />
                    <CardRecomienda
                      img={"/images/valle-vip-5.png"}
                      title={"VALLE VIP"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/valle-vip'}
                    />
                    <CardRecomienda
                      img={"/images/cris-1.png"}
                      title={"CITY TOUR"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/citytour'}
                    />
                    <CardRecomienda
                      img={"/images/maras-moray-4.png"}
                      title={"MARAS-MORAY"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/maras-moray'}
                    />
                  </>
                }
      />
    </>
  );
}
